// import TheLoginForm from "@/Components/Shared/TheLoginForm.vue";
// import TheVerificationMessage from "@/Components/App/TheVerificationMessage.vue";
// import AppArticleProp from "@/Components/Shared/AppArticleProp.vue";

import { useModal } from "@/Utils/use-modal";
import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";
import TheLoginForm from "@/Components/App/forms/TheLoginForm.vue";
import TheVerificationMessage from "@/Components/App/notifications/TheVerificationMessage.vue";
import AppArticleProp from "@/Components/Shared/article/AppArticleProp.vue";
import TheNewProductMessage from "@/Components/App/interface/TheNewProductMessage.vue";
// import TheNewProductMessage from "@/Components/App/TheNewProductMessage.vue";

const { openModal } = useModal();
export const apiPathUrl = (path: any) => `/api${path}`;

// checks
export const isAdmin = computed(
    () => usePage().props?.prodct?.isAdmin || false,
);
export const isGuest = computed(() => usePage().props.prodct.isGuest);
export const isVerified = computed(() => usePage().props.prodct.isVerified);
export const isLoggedIn = computed(() => usePage().props.prodct.isLoggedIn);

export const is2FA = computed(() => usePage().props?.prodct?.is2FA || false);
export const authUser = computed(
    () => usePage().props?.prodct?.authUser || null,
);

// export const isCurrentUser = computed(() => {
//     return isLoggedIn.value && usePage().props.user.data
//         ? usePage().props.prodct.auth.data.id === usePage().props.user.data.id
//         : false;
// });
// export const currentUserId = computed(() => {
//     return usePage().props.prodct.auth
//         ? usePage().props.prodct.auth.data.id
//         : null;
// });

export const isCurrentUserById = (userId: string) => {
    return usePage().props.prodct.authUser &&
        usePage().props.prodct.authUser.data
        ? usePage().props.prodct.authUser.data.id === userId
        : false;
};
//
// methods
//
export const mustBeLogin = () => {
    openModal({
        component: TheLoginForm,
        title: "",
        alert: "Je moet ingelogd zijn om dit te kunnen doen",
    });
};

export const mustBeVerified = () => {
    openModal({
        component: TheVerificationMessage,
        title: "Je account moet geactiveerd zijn om dit te kunnen doen",
    });
};
export const mustBeOwner = () => {
    openModal({
        component: AppArticleProp,
        props: {
            text: "Je bent niet de eigenaar van dit item en kunt deze actie dus niet uitvoeren",
        },
    });
};

export const showNewProductMessage = () => {
    openModal({
        component: TheNewProductMessage,
        title: "",
    });
};

export const truncate = (string: any, amount = 200) => {
    if (!string) {
        return string;
    }

    if (Array.isArray(string)) {
        string = JSON.stringify(string);
    }

    if (string.length > amount) return string.substring(0, amount) + "...";
    else return string;
};

export const unflatten = (arr: any) => {
    const tree: any = [];
    const mappedArr: any = {};
    let arrElem: any;
    let mappedElem: any;

    // First map the nodes of the array to an object -> create a hash table.
    for (let i = 0, len = arr.length; i < len; i++) {
        arrElem = arr[i];
        mappedArr[arrElem.id] = arrElem;
        mappedArr[arrElem.id]["children"] = [];
    }

    for (const id in mappedArr) {
        if (Object.prototype.hasOwnProperty.call(mappedArr, id)) {
            mappedElem = mappedArr[id];
            // If the element is not at the root level, add it to its parent array of children.
            if (mappedElem.parent_id) {
                mappedArr[mappedElem["parent_id"]]["children"].push(mappedElem);
            }
            // If the element is at the root level, add it to first level elements array.
            else {
                tree.push(mappedElem);
            }
        }
    }
    return tree;
};

export const scrollIntoViewWithOffset = (element: any) => {
    if (typeof window !== "undefined") {
        element.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }
};

export const multiselectClasses = {
    container:
        "relative text-slate-700 mx-auto w-full flex items-center justify-end box-border cursor-pointer border border-slate-300 bg-white text-base leading-snug outline-none",
    containerDisabled: "cursor-default bg-gray-100",
    containerOpen: "rounded-b-none",
    containerOpenTop: "rounded-t-none",
    containerActive: "ring ring-green-500 ring-opacity-30",
    wrapper:
        "relative mx-auto h-full w-full flex items-center justify-end box-border cursor-pointer outline-none",
    singleLabel:
        "flex items-center h-full max-w-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-2 pr-16 box-border rtl:left-auto rtl:right-0 rtl:pl-0 rtl:pr-3.5",
    singleLabelText:
        "overflow-ellipsis overflow-hidden block whitespace-nowrap max-w-full",
    multipleLabel:
        "flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-2 rtl:left-auto rtl:right-0 rtl:pl-0 rtl:pr-3.5",
    search: "w-full absolute inset-0 outline-none focus:ring-0 appearance-none box-border border-0 text-base font-sans bg-white rounded pl-2 rtl:pl-0 rtl:pr-3.5",
    tags: "flex-grow flex-shrink flex flex-wrap items-center mt-1 pl-2 min-w-0 rtl:pl-0 rtl:pr-2",
    tag: "bg-green-500 text-white text-sm font-semibold py-0.5 pl-2 rounded mr-1 mb-1 flex items-center whitespace-nowrap min-w-0 rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1",
    tagDisabled: "pr-2 opacity-50 rtl:pl-2",
    tagWrapper: "whitespace-nowrap overflow-hidden overflow-ellipsis",
    tagWrapperBreak: "whitespace-normal break-all",
    tagRemove:
        "flex items-center justify-center p-1 mx-0.5 rounded-sm hover:bg-black/10 group",
    tagRemoveIcon:
        "bg-multiselect-remove bg-center bg-no-repeat opacity-30 inline-block w-3 h-3 group-hover:opacity-60",
    tagsSearchWrapper:
        "inline-block relative mx-1 mb-1 flex-grow flex-shrink h-full",
    tagsSearch:
        "absolute inset-0 border-0 outline-none focus:ring-0 appearance-none p-0 text-base font-sans box-border w-full",
    tagsSearchCopy: "invisible whitespace-pre-wrap inline-block h-px",
    placeholder:
        "flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-2 text-gray-400 rtl:left-auto rtl:right-0 rtl:pl-0 rtl:pr-3.5",
    caret: "bg-multiselect-caret bg-center bg-no-repeat w-2.5 h-4 py-px box-content mr-3.5 relative z-10 opacity-40 flex-shrink-0 flex-grow-0 transition-transform transform pointer-events-none rtl:mr-0 rtl:ml-3.5",
    caretOpen: "rotate-180 pointer-events-auto",
    clear: "pr-3.5 relative z-10 opacity-40 transition duration-300 flex-shrink-0 flex-grow-0 flex hover:opacity-80 rtl:pr-0 rtl:pl-3.5",
    clearIcon:
        "bg-multiselect-remove bg-center bg-no-repeat w-2.5 h-4 py-px box-content inline-block",
    spinner:
        "bg-multiselect-spinner bg-center bg-no-repeat w-4 h-4 z-10 mr-3.5 animate-spin flex-shrink-0 flex-grow-0 rtl:mr-0 rtl:ml-3.5",
    infinite: "flex items-center justify-center w-full",
    infiniteSpinner:
        "bg-multiselect-spinner bg-center bg-no-repeat w-4 h-4 z-10 animate-spin flex-shrink-0 flex-grow-0 m-3.5",
    dropdown:
        "max-h-60 absolute -left-px -right-px bottom-0 transform translate-y-full border border-gray-300 -mt-px overflow-y-scroll z-50 bg-white flex flex-col rounded-b",
    dropdownTop:
        "-translate-y-full top-px bottom-auto rounded-b-none rounded-t",
    dropdownHidden: "hidden",
    options: "flex flex-col p-0 m-0 list-none",
    optionsTop: "",
    group: "p-0 m-0",
    groupLabel:
        "flex text-sm box-border items-center justify-start text-left py-1 px-3 font-semibold bg-gray-200 cursor-default leading-normal",
    groupLabelPointable: "cursor-pointer",
    groupLabelPointed: "bg-gray-300 text-gray-700",
    groupLabelSelected: "bg-green-600 text-white",
    groupLabelDisabled: "bg-gray-100 text-gray-300 cursor-not-allowed",
    groupLabelSelectedPointed: "bg-green-600 text-white opacity-90",
    groupLabelSelectedDisabled:
        "text-green-100 bg-green-600/50 cursor-not-allowed",
    groupOptions: "p-0 m-0",
    option: "flex items-center justify-start box-border text-left cursor-pointer text-base leading-snug py-2 px-3",
    optionPointed: "text-gray-800 bg-gray-100",
    optionSelected: "text-white bg-green-500",
    optionDisabled: "text-gray-300 cursor-not-allowed",
    optionSelectedPointed: "text-white bg-green-500 opacity-90",
    optionSelectedDisabled: "text-green-100 bg-green-500/50 cursor-not-allowed",
    noOptions: "py-2 px-3 text-gray-600 bg-white text-left rtl:text-right",
    noResults: "py-2 px-3 text-gray-600 bg-white text-left rtl:text-right",
    fakeInput:
        "bg-transparent absolute left-0 right-0 -bottom-px w-full h-px border-0 p-0 appearance-none outline-none text-transparent",
    assist: "absolute -m-px w-px h-px overflow-hidden",
    spacer: "h-9 py-px box-content",
};
